var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t_header",staticStyle:{"z-index":"2"}},[_c('div',{staticClass:"left",on:{"click":_vm.goBack}},[_c('div',{staticClass:"icon"})]),(_vm.title)?_c('div',{staticClass:"tq-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"center"},[_vm._t("center")],2),_c('div',{staticClass:"right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }